import http from '../utils/http-common'

const getAll = (param) => {
  return http.get('/supply-types', { params: param })
}
const SupplyTypesDataService = {
  getAll,
}
export default SupplyTypesDataService
